function dm_c19() {
    const $btn = $('.c19-load-more');
    const $container = $('.c19-row');
    const $type = $('#filter-type');
    const $location = $('#filter-location');
    const $date = $('#filter-date');
    let page = 1;
    const maxPages = parseInt($container.data('max-pages') || 9999);

    function loadEvents(reset = false) {
        if (reset) {
            page = 1;
            $container.empty();
            $btn.show().text('Load more +');
        } else {
            page++;
        }

        $.ajax({
            url: dm_loadmore.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'dm_load_more_events',
                nonce: dm_loadmore.nonce,
                page: page,
                type: $type.val(),
                location: $location.val(),
                date: $date.val(),
            },
            beforeSend: function() {
                $btn.text('Loading...');
            },
            success: function(res) {
                if (res.success) {
                    $container.append(res.data.html);
                    if (page >= res.data.max_pages) {
                        $btn.hide();
                    } else {
                        $btn.text('Load more +');
                    }
                } else {
                    if (reset) {
                        $container.html('<div class="col-lg-8 offset-lg-2"><p>No events found with the selected filters.</p></div>');
                    }
                    $btn.hide();
                }
            },
            error: function() {
                $btn.text('Error');
            }
        });
    }

    $btn.on('click', function() {
        loadEvents();
    });

    $type.add($location).add($date).on('change', function() {
        loadEvents(true);
    });
}

export { dm_c19 };
